import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PermissionsComponent implements OnInit {
  public title: string = String('Cookie disabled');
  public detail: string = String('Please enable cookie before using Vitay');

  constructor() {}

  ngOnInit(): void {}
}
